import { render } from "./MUpgradeVIP.vue?vue&type=template&id=b924fcbe&scoped=true"
import script from "./MUpgradeVIP.vue?vue&type=script&lang=js"
export * from "./MUpgradeVIP.vue?vue&type=script&lang=js"

import "./MUpgradeVIP.vue?vue&type=style&index=0&id=b924fcbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b924fcbe"]])

export default __exports__